import { render, staticRenderFns } from "./CreateDemoRequest.vue?vue&type=template&id=143d248a&scoped=true&"
import script from "./CreateDemoRequest.vue?vue&type=script&lang=js&"
export * from "./CreateDemoRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreateDemoRequest.vue?vue&type=style&index=0&id=143d248a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d248a",
  null
  
)

export default component.exports